import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { Link } from 'react-router';
import Dish from "./components/Dish";
import Layout from "../layout";
import pages from '../../subscriber/Pages';
import staticBlogs from '../../data/blogs.json';
import SeoHelmet from '../../components/SeoHelmet';
import HeroSection from '../../components/HeroSection';
import { languageStore } from '../../subscriber/Language';
import { getArray, getArrayLength } from '../../utils/helpers';
import { getServices } from '../../provider/Service';

// Import images
import heroImage from "../../assets/chef_luca_table_setting.png";

const ServicesPage = () => {
    const [hydrated, setHydrated] = useState(false);
    const { services } = pages

    useEffect(() => {
        setHydrated(true);
        if (getArrayLength(services) === 0) {
            getServices();
        }
    }, [services]);

    const { getPageTranslations } = languageStore;
    const t = getPageTranslations('services');

    // 👇 SEO meta only from Home
    const seoServices = staticBlogs.find(b => b.slug === 'services');

    const renderMain = () => {
        if (!hydrated) return null;
        return (
            <div className="bg-[#FFEDE1]">
                {/* Hero Section */}
                <HeroSection 
                    backgroundImage={heroImage}
                    title={t.title}
                />
                
                {/* Services Content */}
                <section className="py-24 px-4 bg-[#fff]">
                    <div className="max-w-6xl mx-auto">
                        <div className="px-[17%]">
                            <h5 className="text-[#C7702A] font-jost text-base font-normal uppercase mb-2 text-center">{t.title}</h5>
                            <h2 className="text-[#1F0707] text-[45px] font-medium leading-[1.2em] tracking-[-0.015em] mb-12 font-libre-caslon text-center">{t.subtitle}</h2>
                        </div>
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
                            {getArray(services).map((service, index) => (
                                <div key={index} className="bg-white rounded-lg overflow-hidden shadow-lg">
                                    <Link to={`/service_detail/${service?.slug}`} className="block">
                                        <img 
                                            src={service?.image} 
                                            alt={service?.name} 
                                            width={300}
                                            height={200}
                                            className="w-full h-64 object-cover duration-300 hover:scale-105"
                                        />
                                        <div className="p-6">
                                            <h4 className="text-[#1F0707] font-['Libre_Caslon_Display',sans-serif] text-[28px] font-libre-caslon font-normal leading-[28.8px] mb-[6px] mt-0 text-size-adjust-100 unicode-bidi-isolate word-spacing-0">{service.name}</h4>
                                            <p className="text-[rgba(31,7,7,0.62)] font-['Jost',sans-serif] text-[14px] font-normal leading-[28.8px] mb-[14.4px] text-size-adjust-100 unicode-bidi-isolate">{service.sort_description}</p>
                                        </div>
                                        <div className="flex items-center justify-end text-[14px] text-[#1F070799] mb-4 mr-3">
                                            <span className="text-[#D3752B] transition-colors duration-300 text-right">
                                                {t?.readMore}
                                            </span>
                                        </div>
                                    </Link>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                {/* Booking Process */}
                {/* <section className="py-24 px-4 bg-[#FFEDE1]">
                    <div className="max-w-6xl mx-auto">
                        <h5 className="text-[#C7702A] font-jost text-base font-normal uppercase mb-2 text-left">{t.bookingProcess.title}</h5>
                        <h2 className="text-[#1F0707] text-[45px] font-medium leading-[1.2em] tracking-[-0.015em] mb-12 font-libre-caslon text-left">{t.bookingProcess.subtitle}</h2>

                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
                            {getArray(bookingProcess.steps).map((step, index) => (
                                <div key={index} className="flex flex-col items-start">
                                    <div className="flex items-center w-full mb-4">
                                        <div className="bg-[#D3752B] text-white font-bold text-xl w-12 h-12 flex items-center justify-center">
                                            {step.number}
                                        </div>
                                        <div className="h-[1px] bg-[#D3752B] flex-grow mx-4 ml-8 mr-28 md:mr-28 lg:mr-8"></div>
                                    </div>
                                    <h2 className="text-[#1F0707] text-[28px] font-medium leading-[1.2em] tracking-[-0.015em] mb-12 font-libre-caslon text-left mb-2">{step.title}</h2>
                                    <p className="text-[rgba(31,7,7,0.62)] font-['Jost',sans-serif] text-[18px] font-normal leading-[28.8px] unicode-bidi-isolate">{step.description}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </section> */}

                {/* Menu Selections */}
                <Dish t={t} />
                {/* <section className="py-20 bg-[#FFF]">
                    <div className="container mx-auto px-4">
                        <div className="flex flex-wrap items-center">
                            <div className="w-full md:w-1/2 mb-10 md:mb-0">
                                <img 
                                    src={menuImage} 
                                    alt="Menu Selection" 
                                    className="rounded-lg shadow-xl"
                                    width={500}
                                    height={750}
                                    layout="responsive"
                                />
                            </div>
                            <div className="w-full md:w-1/2 md:pl-10">
                                <div className="relative">
                                    <h5 className="text-[#C7702A] uppercase mb-2 font-['Jost',sans-serif] text-[15px] font-normal">{menu.title}</h5>
                                    <h2 className="text-[#1F0707] font-['__Libre_Caslon_Display_20614e'] text-[40px] font-medium tracking-[-0.6px] leading-[48px] mb-6">{menu.subtitle}</h2>
                                    <ul className="space-y-4 mb-8">
                                        {getArray(menu.list).map((item, index) => (
                                            <li key={index} className="flex items-start">
                                                <span className="text-[#C7702A] text-primary-500 mr-2">■</span>
                                                <span className="text-[rgba(31,7,7,0.62)] font-['__Jost_461405'] text-[18px] font-normal leading-[28.8px]">
                                                    <strong className='text-[#1F0707]'>{item.title}</strong>
                                                    <p>{item.description}</p>
                                                </span>
                                            </li>
                                        ))}
                                    </ul>
                                    <p className="relative z-10 text-[rgba(31,7,7,0.62)] font-['__Jost_461405'] text-[18px] font-normal leading-[28.8px] text-left mb-6">{menu.message}</p>
                                    <div
                                        className="absolute inset-0 z-0 bg-no-repeat bg-center bg-contain opacity-35"
                                        style={{
                                            backgroundImage: `url(${leftImage.src})`,
                                            transform: 'rotate(48deg) scale(0.6)',
                                        }}
                                    ></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section> */}
            </div>
        )
    }

    return (
        <Layout>
            <SeoHelmet
                title={seoServices.name}
                description={seoServices.sort_description}
                image={seoServices.path}
                url={seoServices.url}
            />
            {renderMain()}
        </Layout>
    );
};

export default observer(ServicesPage);
